import './index.styl'

export default {
  name: 'Loading',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: 'https://image.wxopen.shenhudong.com/v4-wechat-fonted/static/logo.png'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    return (
      <div class={this.fixed ? 'loading-mask white-mask' : 'loading-mask'} v-show={this.show}>
        <div class="logo">
          <img src={this.imgSrc} alt="logo"/>
        </div>
        <span>Loading...</span>
      </div>
    )
  }
}